export default {
  user: (userId) => `/hrm/HrmTab.jsp?_fromURL=HrmResource&id=${userId}`,//人事信息页面
  cowork: (coworkid) => `main/cowork/main/${coworkid}`,//协作页面
  coworkHref: (coworkid) => `/spa/cowork/static/index.html#/main/cowork/main/${coworkid}`,//协作页面
  coworkSingleHref: (coworkid) => `/spa/cowork/static/index.html#/cowork/${coworkid}`,//协作页面
};


// WEBPACK FOOTER //
// ../src4js/pc4mobx/cowork/util/InnerHref.js